import { Fragment, type FC } from 'react';
import { ProductAttributeInterface } from '../../../../../Interface/ProductAttribute';
import clsx from 'clsx';
import ProductAttribute from './ProductAttribute/ProductAttribute';

import ProductAnimationContainer from '../../ProductAnimationContainer';
import styles from './ProductAttributeView.module.scss?module';
import useViewports from '../../../../Hooks/useViewports';
import { useUser } from '../../../../Context/UserContext';

type ProductAttributeViewPropsT = {
  data: ProductAttributeInterface[];
  view: string;
  allowBackorder?: boolean;
};

const ProductAttributeView: FC<ProductAttributeViewPropsT> = ({
  data,
  view,
  allowBackorder = false,
}) => {
  const { user } = useUser();
  const { xs, sm, md } = useViewports();
  const isMobile = xs || sm || md;

  return (
    <Fragment>
      <div className={clsx(view === 'table' && styles.TableView)}>
        {view === 'table' && !isMobile ? (
          <div className={styles.TableHeader}>
            <div>Brand</div>
            <div>Product</div>
            <div>Variant</div>
            <div className={styles.HeaderInfo}>Info</div>

            {user && user?.id ? (
              <>
                <div className={styles.HeaderPrice}>Price</div>
                <div className={styles.HeaderQty}>Qty</div>
              </>
            ) : null}
          </div>
        ) : null}

        <ProductAnimationContainer
          items={data}
          view={view}
          renderItem={(attribute, index) => (
            <Fragment key={`${attribute.id}-${index + 1}`}>
              <ProductAttribute
                attribute={attribute}
                allowBackorder={allowBackorder}
              />
              {view !== 'table' ? (
                <hr
                  className={clsx(
                    'opacity-25 m-0',
                    index + 1 === data.length ? 'd-none' : ''
                  )}
                />
              ) : null}
            </Fragment>
          )}
        />
      </div>
      <div className="d-none d-md-block pt-4" />
    </Fragment>
  );
};

export default ProductAttributeView;
